import { createContext, useContext } from "react";
import { BrokerLoopWebSocketSDK, type SessionActions } from "@financeable/brokerloop-data-plane";

interface LodgeAIContextType {
  sdk?: BrokerLoopWebSocketSDK;
  sessionActions?: SessionActions;
}

const LodgeAIContext = createContext<LodgeAIContextType>({
  sdk: undefined,
  sessionActions: undefined,
});

const useLodgeAIContext = () => {
  const context = useContext(LodgeAIContext);
  if (!context) {
    throw new Error("useLodgeAIContext must be used within LodgeAIProvider");
  }
  return context;
};

export { LodgeAIContext, useLodgeAIContext };
